<template>
  <el-dialog custom-class="mini-dialog" title="退运费" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">

      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="运费：" :label-width="formLabelWidth" prop="expressfee">
            <el-input-number v-model="form.expressfee" :controls="false" style="width: 200px"
                             :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {freightRefund} from '@/api/set/csagreement';

  export default {
    name: "freightRefund",
    data() {
      let expressfeeRule = (rule, value, callback) => {
        if (value < 0) {
          callback(new Error('请输入正确的运费'));
        } else if (value > this.originalExpressfee) {
          callback(new Error('退货的运费不能大于原运费'));
        }
        else {
          callback();
        }
      }

      return {
        loading:false,
        isDisable: false,
        dialogFormVisible: false,
        form: {  //表单数据
          unitguid: '',
          expressfee: ''//运费
        },
        originalExpressfee: '',//原来的运费
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          expressfee: [
            {validator: expressfeeRule, trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(item) {
        this.initForm();
        this.form.unitguid = item.unitguid
        this.form.expressfee = Math.abs(item.expressfee)
        this.originalExpressfee = item.expressfee
        this.dialogFormVisible = true;
      },
      saveData() {
        this.loading=true;
        this.$refs.form1.validate((valid) => {
          if (valid) {
            freightRefund(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '退款成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                this.$emit('afertFreightRefund', this.form.expressfee);
              } else {
                this.loading=false;
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            })
          }
        });
      },
      initForm() {
        this.loading=false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.originalExpressfee = ''
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/FreightRefund.vue